import { Action, ActionTypes } from "./ActionTypes"
import { User } from "../Definitions/Generated/User";
import { SnackbarStatus, ThemeTypes } from "../Definitions/Definitions";

export function setCurrentUser(newUser: User): Action {
    return {
        type: ActionTypes.SET_CURRENT_USER,
        currentUser: newUser
    }
}

export function setAuthenticated(authenticated: boolean): Action {
    return {
        type: ActionTypes.SET_AUTHENTICATED,
        authenticated: authenticated
    }
}

export function openSnackbar(status: SnackbarStatus, message: string, closeDelay: number): Action {
    return {
        type: ActionTypes.OPEN_SNACKBAR,
        status: status,
        message: message,
        closeDelay: closeDelay
    }
}

export function closeSnackbar(): Action {
    return {
        type: ActionTypes.CLOSE_SNACKBAR,
    }
}

export function setPageTheme(theme: ThemeTypes): Action {
    return {
        type: ActionTypes.SET_PAGE_THEME,
        theme: theme
    }
}